import type { AxiosInstance } from 'axios';
import type { FetchTranslationsParams, TranslationsResponse } from '../../constants';

export const getTranslationApiFetchers = (axiosInstance: AxiosInstance) => {
  const fetchTranslations = async (params: FetchTranslationsParams) => {
    const { data } = await axiosInstance.get<TranslationsResponse[]>(`/console/translations`, {
      params,
    });
    return data;
  };

  return { fetchTranslations };
};
